var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generatePage, createSectionSmart, applyPageWidthToPage, } from 'pxc-editor-core/helpers/schema';
import store from '@/store';
import { ENDLESS_BASED_ON_CONTENT, ENDLESS_FIXED } from '@/constants';
import { getBuildedMatfileTemplate } from './matfile';
export default (function () {
    var _a;
    var _b = store.getState(), _c = _b.core, selWizard = _c.selWizard, ribbonColor = _c.ribbonColor, appSettingsReducer = _b.appSettingsReducer;
    var matfileTemplate = getBuildedMatfileTemplate();
    var generatedPage = generatePage({ material: matfileTemplate, selWizard: selWizard });
    var layouts = generatedPage.layouts;
    var sections = Object.values(layouts).reduce(function (acc, _a) {
        var groups = _a.groups;
        return Object.values(groups).reduce(function (acc1, _a) {
            var shields = _a.shields;
            return Object.values(shields).reduce(function (acc2, shield) {
                var _a, _b;
                var pages = (_a = {}, _a[generatedPage.uid] = generatedPage, _a);
                var section = createSectionSmart({
                    sourceShield: shield,
                    pages: pages,
                    ribbonColor: ribbonColor,
                });
                if (section) {
                    return __assign(__assign({}, acc2), (_b = {}, _b[section.id] = section, _b));
                }
                return acc2;
            }, acc1);
        }, acc);
    }, {});
    var newPage = __assign(__assign({}, generatedPage), { sections: sections });
    switch ((_a = appSettingsReducer.page) === null || _a === void 0 ? void 0 : _a.resizeType) {
        case ENDLESS_BASED_ON_CONTENT: {
            var page = __assign(__assign({}, newPage), { resizeType: ENDLESS_BASED_ON_CONTENT });
            return page;
        }
        case ENDLESS_FIXED: {
            var _d = appSettingsReducer.page.length, length_1 = _d === void 0 ? 30 : _d;
            var page = applyPageWidthToPage(length_1, newPage, selWizard);
            return page;
        }
        default: {
            return newPage;
        }
    }
});
